import React, { useEffect, useState } from "react";
import AuthLayout from "../../layouts/AuthLayout";
import { Box, Stack, Typography, useMediaQuery } from "@mui/material";
import {
  CustomInput,
  CustomPasswordInput,
} from "../../Components/Common/CustomInput";
import { EmailOutlined, LoginRounded } from "@mui/icons-material";
import { CustomBtn } from "../../Components/Common/CustomBtn";
import { useNavigate } from "react-router-dom";
import axiosInstance, { BASE_URL } from "../../utils/config/config";
import axios from "axios";
import { ErrorSnackbar } from "../../Components/Common/CustomSnackbar";
import { useParams, useLocation } from "react-router-dom";

const ResetPassword = () => {
  const navigate = useNavigate();
  const { email } = useParams();
  const location = useLocation();
  const token = new URLSearchParams(location.search).get("token");
  const [password, setPassword] = useState("");
  const [userId, setUserId] = useState(null);
  const [confirmPassword, setConfirmPassword] = useState("");
  const [errorState, setErrorState] = useState({
    error: false,
    message: "",
  });

  const verifyToken = async () => {
    try {
      if (!token) {
        setErrorState({ error: true, message: "No token provided." });
        return;
      }

      const response = await axios.post(`${BASE_URL}/user/verifyToken`, {
        token,
      });

      setUserId(response.data.userId);
    } catch (err) {
      console.log(err);
      setErrorState({
        error: true,
        message: "There was an error verifying the token.",
      });
    }
  };

  const resetPassword = async () => {
    if (password !== confirmPassword) {
      setErrorState({ error: true, message: "Passwords not matching." });
      return;
    }

    try {
      const response = await axios.post(`${BASE_URL}/user/reset-password`, {
        userId,
        token,
        password,
      });

      if (response.status == 200) {
        navigate("/login");
      } else {
        setErrorState({ error: true, message: "Failed to reset password." });
      }
    } catch (err) {
      console.log(err);
      setErrorState({ error: true, message: "Couldn't save new password." });
    }
  };
  const smallScreen = useMediaQuery("(max-width:800px)");

  useEffect(() => {
    verifyToken();
  }, []);

  return (
    <AuthLayout forgotPass>
      <Box>
        <Typography
          sx={{
            fontSize: "22px",
            fontFamily: "Inter-SemiBold",
            color: "#000",
            mb: 4,
          }}
        >
          Enter your new password.
        </Typography>
        <Stack
          direction={"column"}
          sx={{
            justifyContent: "space-between",
            alignItems: "center",
          }}
          gap={2}
        >
          <CustomPasswordInput
            placeholder="Password"
            value={password}
            setValue={setPassword}
          />

          <CustomPasswordInput
            placeholder="Confirm Password"
            value={confirmPassword}
            setValue={setConfirmPassword}
          />
        </Stack>

        <Stack
          direction={"row"}
          sx={{
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <CustomBtn
            text="Save Password"
            Icon={LoginRounded}
            width={smallScreen ? "75%" : "50%"}
            onClick={resetPassword}
          />
        </Stack>
      </Box>
      <ErrorSnackbar
        error={errorState.error}
        handleCloseError={() => setErrorState({ error: false, message: "" })}
        errorMsg={errorState.message}
      />
    </AuthLayout>
  );
};

export default ResetPassword;
